import type { SxProps, Theme } from "@mui/material";

export const referenceSearchPrimaryNameSx: SxProps<Theme> = (theme) => ({
    color: theme.palette.primary[700],
});

export const referenceSearchSecondaryTextSx: SxProps<Theme> = (theme) => ({
    color: theme.custom.grey[2000],
});
